module.exports = __webpack_public_path__ + "static/media/myImg.ce2f78a8.jpeg";